import * as api from '../services/iciciInstantQueue';

export const ICICI_CASE_CLAIMED = 'ICICI_CASE_CLAIMED';

export const ICICI_QUEUE_LOAD       = 'ICICI_QUEUE_LOAD';
export const ICICI_QUEUE_UPDATE     = 'ICICI_QUEUE_UPDATE';
export const ICICI_QUEUE_ERROR      = 'ICICI_QUEUE_ERROR';
export const ICICI_DOCTOR_STATE_SET = 'ICICI_DOCTOR_STATE_SET';
export const ICICI_CALL_STARTED          = 'ICICI_CALL_STARTED';

export const loadOpsState = () => async (dispatch) => {
  try {
    const data = await api.getOpsState();
    dispatch({ type: ICICI_QUEUE_LOAD, payload: data });
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
  }
};

// Called by PubNub listener when server pushes an ops_queue_update event
export const applyOpsUpdate = (payload) => ({
  type: ICICI_QUEUE_UPDATE,
  payload,
});

export const doManualAssign = (consultationId, doctorId) => async (dispatch) => {
  await api.manualAssign(consultationId, doctorId);
  // Server broadcasts ops update via PubNub; no need to reload manually
};

export const loadDoctorState = () => async (dispatch) => {
  try {
    const data = await api.getDoctorState();
    dispatch({ type: ICICI_DOCTOR_STATE_SET, payload: data });
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
  }
};

export const changeDoctorStatus = (status) => async (dispatch) => {
  try {
    await api.setDoctorStatus(status);
    dispatch(loadDoctorState());
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
  }
};

export const doStartCall = (consultationId) => async (dispatch) => {
  try {
    const data = await api.startCall(consultationId);
    dispatch({ type: ICICI_CALL_STARTED, payload: data });
    return data;
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
    return null;
  }
};

export const doCompleteCall = (consultationId) => async (dispatch) => {
  try {
    await api.completeCall(consultationId);
    dispatch(loadDoctorState());
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
  }
};

export const doClaimCase = (consultationId) => async (dispatch) => {
  try {
    const data = await api.claimCase(consultationId);
    if (data && data.status === 'success') {
      dispatch({ type: ICICI_CALL_STARTED, payload: data });
    }
    return data;
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
    return null;
  }
};

export const setOpsDoctorStatus = (doctorId, status) => async (dispatch) => {
  try {
    await api.setOpsDoctorStatus(doctorId, status);
    dispatch(loadOpsState());
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
  }
};

export const doRegisterInstantCase = (payload) => async (dispatch) => {
  try {
    const data = await api.registerInstantCase(payload);
    if (data && (data.status === 'success' || data.status === 'duplicate')) {
      dispatch(loadOpsState());
    }
    return data;
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
    return { status: 'failure', errorMessage: err.message };
  }
};

export const doBulkGenerateInstantLinks = (applicationIds) => async (dispatch) => {
  try {
    const data = await api.bulkGenerateInstantLinks(applicationIds);
    if (data && data.status === 'success') {
      dispatch(loadOpsState());
    }
    return data;
  } catch (err) {
    dispatch({ type: ICICI_QUEUE_ERROR, payload: err.message });
    return { status: 'failure', errorMessage: err.message };
  }
};
